/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { type ReactNode } from 'react';
import { css, jsx, keyframes } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// TODO: this will be deprecated eventually once the dependent experiment moves to a better design without pulse spotlight

const reduceMotionAsPerUserPreference = css({
	'@media (prefers-reduced-motion: reduce)': {
		animation: 'none',
		transition: 'none',
	},
});

type PulseProps = {
	children?: ReactNode;
	radius: number;
	testId?: string;
	pulse?: boolean;
	style?: React.CSSProperties;
};

// NOTE:
// Pulse color "rgb(101, 84, 192)" derived from "colors.P300"
const easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const pulseKeyframes = keyframes({
	'0%, 33%': {
		boxShadow: `0 0 0 2px ${token('color.border.discovery')}, 0 0 0 ${token('color.border.discovery')}`,
	},
	'66%, 100%': {
		boxShadow: `0 0 0 2px ${token('color.border.discovery')}, 0 0 0 10px rgba(101, 84, 192, 0.01)`,
	},
});

const animationStyles = css({
	animationDuration: '3000ms',
	animationIterationCount: 'infinite',
	animationName: pulseKeyframes,
	animationTimingFunction: easing,
	// Keep a purple boxshadow on the Pulse component if `prefers-reduced-motion`
	// is applied so we still have a functioning semantic affordance.
	boxShadow: `0 0 0 2px ${token('color.border.discovery')}`,
});

/**
 * __Pulse component__
 *
 * A pulse effect that draws attention to elements. This is a local implementation
 * extracted from @atlaskit/onboarding to avoid external dependencies.
 *
 * TODO: this will be deprecated eventually once the dependent experiment moves to a better design without pulse spotlight
 */
export const Pulse = ({
	children,
	radius,
	pulse = true,
	testId,
	style,
}: PulseProps) => {
	return (
		<div
			data-testid={testId}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Custom styles from props
			style={{ ...style, borderRadius: `${radius}px` }}
			css={[pulse && animationStyles, reduceMotionAsPerUserPreference]}
		>
			{children}
		</div>
	);
};
